var _polygon, _line, _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectionRtl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "ql-stroke ql-fill",
    points: "15 12 13 10 15 8 15 12"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "ql-stroke ql-fill",
    x1: 9,
    x2: 5,
    y1: 4,
    y2: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ql-fill",
    d: "M5,3A3,3,0,0,0,5,9H6V3H5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ql-fill",
    height: 11,
    width: 1,
    x: 5,
    y: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "ql-fill",
    height: 11,
    width: 1,
    x: 7,
    y: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionRtl);
export default __webpack_public_path__ + "static/media/direction-rtl.1375883b2f1e6de4a4621aca550cbd1d.svg";
export { ForwardRef as ReactComponent };